import { Tabs as AntTabs, TabsProps } from 'antd';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { BFC } from '@/shared/types';

export const Tabs: BFC<TabsProps> = (props) => {
  return <StyledTabs {...props} />;
};

const StyledTabs = styled(AntTabs)`
  &&& {
    .ant-tabs-nav {
      margin-bottom: 24px;
    }

    .ant-tabs-tab {
      padding: 6px 16px;
    }

    .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 4px;
    }

    .ant-tabs-tab-btn {
      font-size: 16px;
      color: ${COLORS.systemDark200};
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${COLORS.systemSky200};
      font-weight: 700;
      text-shadow: none;
    }

    .ant-tabs-ink-bar {
      background: ${COLORS.systemSky200};
    }

    .ant-tabs-tabpane-active {
      visibility: visible;
    }

    ${media.sm} {
      .ant-tabs-nav {
        margin-bottom: 16px;
      }

      .ant-tabs-tab {
        text-align: center;
        width: 100%;
      }

      .ant-tabs-tab-btn {
        text-align: center;
        align-items: center;
        justify-content: center;
        width: 100%;
      }
    }
  }
`;
